import { render, staticRenderFns } from "./salesSettingUnitForm.vue?vue&type=template&id=4b632c3a&scoped=true"
import script from "./salesSettingUnitForm.vue?vue&type=script&lang=js"
export * from "./salesSettingUnitForm.vue?vue&type=script&lang=js"
import style0 from "./salesSettingUnitForm.vue?vue&type=style&index=0&id=4b632c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b632c3a",
  null
  
)

export default component.exports